import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { apiFetch } from '../../helpers/api';
import Loader from '../common/Loader';
import './News.css';

const NewsDetails = () => {
  const { id } = useParams();
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImg, setLightboxImg] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchNewsItem = async () => {
      try {
        const data = await apiFetch(`/api/news/${id}`);
        setNewsItem(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load news item.");
      } finally {
        setLoading(false);
      }
    };
    fetchNewsItem();
  }, [id]);

  if (loading) return <Loader />;
  if (error) return <div>{error}</div>;
  if (!newsItem) return <div>News not found.</div>;

  const extraImages = newsItem.extraImages || [];

  const openLightbox = (img) => {
    setLightboxImg(img);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    setLightboxImg(null);
  };

  return (
    <div className="news-details-container">
      <Link to="/aboutUs" className="back-link">← Back</Link>
      <h2>{newsItem.title}</h2>
      <img 
        src={newsItem.imageUrl || newsItem.image} 
        alt={newsItem.title} 
        onError={e => e.target.src = 'https://picsum.photos/600/300?random=3'}
        className="news-details-image"
      />
      <p className="news-details-description">{newsItem.description}</p>

      {extraImages.length > 0 && (
        <div className="news-extra-images-wrapper">
          {extraImages.map((img, idx) => (
            <div key={idx} className="news-extra-image-card" onClick={() => openLightbox(img)}>
              <img
                src={img}
                alt={`Extra ${idx+1}`}
                onError={e => e.target.src='https://picsum.photos/300/200?random=3'}
              />
            </div>
          ))}
        </div>
      )}

      {lightboxOpen && (
        <div className="lightbox-overlay" onClick={closeLightbox}>
          <img
            className="lightbox-image"
            src={lightboxImg}
            alt="Full view"
            onClick={(e) => e.stopPropagation()} // STOP click from bubbling
          />
          <button className="lightbox-close-btn" onClick={closeLightbox}>×</button>
        </div>
      )}
    </div>
  );
};

export default NewsDetails;
